import { Component, OnInit, Input, ViewChild, OnDestroy } from '@angular/core';
import { UtilsService } from 'src/app/utils/utils.service';
import { ConstantsModule } from '../../shared/constants/constants.module';
import { ObservedWeatherDataService } from './observed-weather-data.service';
import { Observable, Subscription } from 'rxjs';
import { UtilsSharedModule } from '../../shared/utils/utils/utils.module';
import { DatepickerComponent } from 'src/app/utils/datepicker/datepicker.component';
import { ActivatedRoute, Router, NavigationEnd, Event } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InfomodalComponent } from '../../shared/infomodal/infomodal.component';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { isNullOrUndefined } from 'util';
import { ObservedRainfallDataService } from './observed-rainfall/observed-rainfall-data.service';
import { ObservedWeatherMapService } from './observed-weather-map.service';

@Component({
  selector: 'app-observed-weather',
  templateUrl: './observed-weather.component.html',
  styleUrls: ['./observed-weather.component.scss']
})
export class ObservedWeatherComponent implements OnInit, OnDestroy {

  @Input() labelStrings: any;

  adminSelected: any = true;
  paramsForFilter: any;
  srcParams: any;
  sourceList: any = [];
  list: any;
  defaultSource = 'IMD';
  defaultAggrType = 'SUM';
  srcList: any;
  src: object = { required: true };
  format: object = { required: true };
  aggr: object = { required: true };
  srcUUID: string;
  minDate: Date;
  maxDate: any;
  defaultFormat: any;
  defaultSDate: any;
  customOption = false;
  selectedvalue = 'Live Weather';
  minMaxselected = 'max';
  selectedcomp: any;
  tooltipVal: any;
  modalRef: any;

  mobileSubmit = false;

  sDate: object = { required: true };
  eDate: object = { required: true };
  ytd: object = { required: true };

  ADMIN = 'ADMIN';
  BASIN = 'BASIN';

  dateDropdown = ['Live Weather', 'Yesterday', 'Last 3 Days', 'Last 7 Days', 'Last 14 Days', 'MTD', 'Monsoon YTD', /*'Custom'*/];

  dashboardView: string = this.ADMIN;
  validation: boolean[] = new Array(5).fill(true);

  selectedView = this.constants.VIEWS.ADMIN;
  mapLoaderActive = false;

  currentApplication: any;
  selectedLocation:any = 'INDIA##00cb31c7-2928-4e6d-adcc-443d478c90d6';
  countryUUID = '00cb31c7-2928-4e6d-adcc-443d478c90d6'

  @ViewChild(DatepickerComponent, {
    static: false
  }) datepicker: DatepickerComponent;
  selected: string;
  moduleName: any;
  forecastLength: string;
  stateUrlId: string;
  stateName: any;
  stateUUID: any;
  navigationSubscription: Subscription;
  subscriptions: Subscription[] = [];
  MobileCustomSetting = false;
  locationList:any = []
  sourcelist:any = ['CWC','IMD_STATIONS','IMD_GRID','MERGED_STATIONS','IMD_PRN_STATIONS']
  selectedSource:any = 'IMD_STATIONS'
  cType: any = 'STATE';
  pType: any = 'COUNTRY';
  latitude: any = {};
  longitude: any = {};
  constructor(
    public utilsShared: UtilsSharedModule,
    private utils: UtilsService,
    public constants: ConstantsModule,
    private weatherDataService: ObservedWeatherDataService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal,
    private rfSrv: ObservedRainfallDataService,
    private mapSrv: ObservedWeatherMapService
  ) {
    this.navigationSubscription = router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.selected = router.url.split('/')[2];
      }
    });
    this.subscriptions.push(this.navigationSubscription);
  }

  ngOnInit() {
    setTimeout(() => {
      window.location.reload();
    }, 3600000);
    // this.utils.minMaxToggle.subscribe(val => {
    //   this.minMaxselected = val;
    // })
    this.setActiveComponent();
    this.utils.getQueryParams().subscribe(() => {
      this.initializeOnStateLoad();
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  adminBasinToggle() {
    this.adminSelected = !this.adminSelected;
    this.utils.setAdminBasinToggle(this.adminSelected);
  }

  minMaxToggle(value) {
    this.minMaxselected = value;
    this.utils.minMaxToggle.next(this.minMaxselected.toLowerCase());
  }

  setActiveComponent() {
    const url = this.router.url;
    this.stateName = ProjConstants.IDTOCOUNTRYNAMEMAPPING[this.route.snapshot.paramMap.get('id')];
    this.stateUUID = ProjConstants.IDTOUUIDMAPPING[this.route.snapshot.paramMap.get('id')];
    this.selected = url.split('/')[2];
    this.selectedcomp = this.selected.split('-')[0];
    this.moduleName = url.split('/')[1];
    this.forecastLength = this.route.snapshot.paramMap.get('time');
    if (this.forecastLength != null && this.forecastLength != undefined) {
      this.forecastLength = this.forecastLength + '/';
    } else {
      this.forecastLength = '';
    }
    this.stateUrlId = this.route.snapshot.paramMap.get('id');
  }

  initializeOnStateLoad() {
    this.paramsForFilter = this.getParams();
    if (this.paramsForFilter['view'] == this.constants.VIEWS.BASIN) {
      this.adminSelected = false;
    }
    this.currentApplication = this.paramsForFilter['component'];
    if (this.paramsForFilter['component']) {
      this.srcParams = 'IMD';
      this.setAllOtherParameters(this.getParams());
      this.dashboardView = this.paramsForFilter['view'] ? this.paramsForFilter['view'] : this.constants.VIEWS.ADMIN;
    }
  }

  getParams() {
    const paramsForFilter = this.utils.getQueryParamsValue();
    this.utils.getDateRange().subscribe(date => {
      paramsForFilter['daterange'] = date;
    });
    // console.log("here", paramsForFilter);
    return paramsForFilter;
  }

  async setsourcelist(options: any) {
    if (this.selectedvalue == 'Live Weather') {
      this.sourceList = [];
      this.list.forEach((srcc: any) => {
        const obj = srcc;
        if (srcc['current'] == true) {
          this.sourceList.push(obj);
        }
      });
      this.sourceList.forEach(src => {
        if (src['key'] == this.constants.AP_AWS) {
          this.tooltipVal = src['displayNames']['basin']['info']['current'];
        }
      });
    } else {
      this.sourceList = this.list;
      this.sourceList.forEach(src => {
        if (src['key'] == this.constants.AP_AWS) {
          this.tooltipVal = src['displayNames']['basin']['info']['historical'];
        }
      });
      if (options['component'] == this.constants.COMPONENT.TEMPERATURE || options['component'] == this.constants.COMPONENT.HUMIDITY) {
        this.src['value'] = this.sourceList[0]['key'];
      } else {
        this.src['value'] = this.constants.AP_AWS;
      }
    }
    this.utils.setSourceList(this.sourceList);
  }

  getToolTipValue() {
    return this.tooltipVal;
  }

  async setDateRangeParametere(options: any) {

    await this.setsourcelist(options);

    const source = this.src['value'];
    const len = this.list.length;
    options['src'] = source;
    this.list.forEach(val => {
      if (source == val['key'] && val['current'] != true) {
        if (len == 1) {
          options['src'] = this.sourceList[0]['key'];
        } else {
          options['src'] = this.constants.AP_AWS;
        }
      }
    });
    this.setSource(options['src']);
    this.eDate['value'] = this.utilsShared.getModelDateWithDateFormat(this.getLastFewDaysDate(0), this.getParams()['format']);
    this.sDate['value'] = this.utilsShared.getModelDateWithDateFormat(this.getLastFewDaysDate(0), this.getParams()['format']);
    this.setAggregation(options['aggr']);
    this.mapLoaderActive = false;
  }

  async setAllOtherParameters(options: any) {
    // to remove cwc
    // for other states state uuid
    // let sUUID = ProjConstants.STATETOUUIDMAPPING[ProjConstants.IDTOSTATENAMEMAPPING[this.stateUrlId]]
    // const postdata = {
    //   component: options['component'],
    //   state_uuid: this.stateUUID
    // };
    // this.list = await this.weatherDataService.getSourceListForComponent(postdata).toPromise();
    // let index = this.list.findIndex(src => src['key'] == this.constants.AP_AWS);
    // if (index == -1) {
    //   index = 0;
    // }
    // if (index != 0) {
    // // if (index != 0 && options['component']!=this.constants.COMPONENT.WINDSPEED) {
    //   this.list.splice(0, 0, this.list.splice(index, 1)[0]);
    // }
    let range;
    // // console.log("Eureka",this.list, this.selectedvalue);
    // await this.setsourcelist(options);

    // this.sourceList.forEach((srcc: any) => {
    //   if (options['src'] == srcc['key']) {
    //     range = srcc['minmax'];
    //   }
    // });
    // if(options['component']==this.constants.COMPONENT.WINDSPEED)
    // options['src']=this.constants.IMD;
    // else
    // options['src']=this.constants.AP_AWS;
    if(this.locationList.length == 0) {
      this.getLocationList(options)
    }
    this.src['value'] = 'CWC'
    // this.setSource(options['src']);
    // let bound = await this.initMinMaxBounds(this.currentApplication, options['src']).toPromise();//.subscribe(response => this.setMinMax(response));
    this.setMinMax(range);
    this.setYTD(range);
    // this.setWaterYear();
    this.setFormat(options['format']);
    if(this.format['value'] != 'HOURLY') {
        this.setStartDate(this.utilsShared.getDateObjectFromModelDate(options['sDate']));
        this.setEndDate(this.utilsShared.getDateObjectFromModelDate(options['eDate']));
    }
    this.setAggregation(options['aggr']);
    this.mapLoaderActive = false;
  }

  async setSource(source: string, reload: boolean = true) {

    const params = this.getParams();
    // for other states state uuid
    // let sUUID = ProjConstants.STATETOUUIDMAPPING[ProjConstants.IDTOSTATENAMEMAPPING[this.stateUrlId]]
    // const postdata = {
    //   component: params['component'],
    //   state_uuid: this.stateUUID
    // };
    // if (!this.srcList) {
    //   this.srcList = await this.weatherDataService.getSourceListForComponent(postdata).toPromise();
    // }
    // let index = this.list.findIndex(src => src['key'] == this.constants.AP_AWS);
    // if (index == -1) {
    //   index = 0;
    // }
    // if (index != 0) {
    //   this.srcList.splice(0, 0, this.list.splice(index, 1)[0]);  //for default imd needs to be comment out
    // }
    // let range;

    // this.srcList.forEach((srcc: any) => {
    //   if (source == srcc['key']) {
    //     range = srcc['minmax'];
    //   }
    // });
    // let dateRange;
    // this.src['value'] = source || this.defaultSource;
    this.selectedSource = source

    // this.srcList.forEach(src => {
    //   if (src['key'] == this.src['value']) {
    //     this.srcUUID = src['agencyUUID'];
    //   }
    // });
    // if (this.src['value'] != undefined) {
    //   this.validation[0] = true;
    // }
    // const bound = await this.initMinMaxBounds(this.currentApplication, this.src['value']).toPromise();
    // if (this.selectedvalue == 'Custom') {
    //   this.setMinMax(range);
    //   this.setYTD(range);
      // console.log("check date range ::",params['sDate'],params['eDate'],this.minDate,this.maxDate)
      // dateRange = this.waterDataService.checkDateRange(this.utils.getDateObjectFromModelDate(params['sDate']),this.utils.getDateObjectFromModelDate(params['eDate']),this.minDate,this.maxDate);
    //   dateRange = this.setWaterYear();
    //   if (reload) {
    //     this.sDate['value'] = this.utilsShared.getDateObjectFromModelDate(params['sDate']);
    //     this.eDate['value'] = this.utilsShared.getDateObjectFromModelDate(params['eDate']);
    //   } else {
    //     this.sDate['value'] = dateRange['defaultSDate'];
    //     this.eDate['value'] = dateRange['defaultEDate'];
    //   }
    // }
    // this.updateSourceValue(this.src['value'],this.sourceList)
    // console.log(" this.src['value'] :", this.src,this.sourceList);
  }

  updateSourceValue(key,sourceList){
    sourceList.forEach((eachobj) =>{
      console.log(eachobj,this.selectedView)
      if(eachobj.key == key){
        console.log(eachobj.displayNames[this.adminSelected ? 'admin' : 'basin']['text'])
        this.utils.setObservedWeathersourceData(eachobj.displayNames[this.adminSelected ? 'admin' : 'basin']['text'])
      }
    })
  }

  initMinMaxBounds(application, src): Observable<any> {
    return this.weatherDataService.getDateRangeForComponent(application, src);
  }

  setMinMax(range: object): void {
    if (!range || !range['MAX'] || range['MAX'] == 0 || !range['MIN'] || range['MIN'] == 0) {
      let today = new Date();
      let Yesterday = new Date(today.getFullYear()-1, 10, 12);
      this.minDate = new Date(Yesterday);
      this.maxDate = new Date();
      return;
    }
    this.minDate = this.utilsShared.getDateObjectFromModelDate(range['MIN'].toString());
    this.maxDate = this.utilsShared.getDateObjectFromModelDate(range['MAX'].toString());
    this.maxDate = (this.maxDate.getTime() > (new Date()).getTime()) ? new Date() : this.maxDate;

  }

  setYTD(data: object): void {
    if (!data || !data['MAX'] || data['MAX'] == 0) { return; }
    this.ytd['value'] = data['MAX'].toString().substr(0, 4);
    Object.assign(this.ytd, data);
  }

  setWaterYear() {
    const obj = this.utilsShared.setWaterYear(this.maxDate, this.minDate);
    this.defaultFormat = obj['format'];
    this.defaultSDate = obj['defaultSDate'];
    this.defaultSDate = obj['defaultEDate'];
    return obj;
  }

  setFormat(format: string): void {
    this.format['value'] = this.getFormat(format) || this.defaultFormat;
    if (this.format['value'] != 'HOURLY') {
      if (this.sDate['value']) {
        delete this.sDate['value'];
      }
      if (this.eDate['value']) {
        delete this.eDate['value'];
      }
    } else {
      let today = new Date();
      // let Yesterday = new Date(today.getFullYear(), 10, 12);
      let Yesterday = new Date(today);
      Yesterday.setDate(today.getDate() - 1)
      this.sDate['value'] = this.utilsShared.getModelDateWithDateFormat(Yesterday, this.format['value'])
      this.eDate['value'] = this.utilsShared.getModelDateWithDateFormat(today, this.format['value'])
    }
    for (let i = 0; i < this.validation.length; i++) {
      this.validation[i] = true;
    }
  }

  getFormat(format) {
    if (format == 'DAILY') {
      return 'yyyyMMdd';
    } else if(format == 'MONTHLY') {
      return 'yyyyMM';
    } else if (format == 'YEARLY') {
      return 'yyyy';
    } else {
      return format;
    }
  }

  setStartDate(date: Date): void {
    this.sDate['value'] = date;  //this.utils.getDateObjectFromModelDate(this.ytd['value']);
  }

  setEndDate(date: Date): void {
    this.eDate['value'] = date; //this.utils.getDateObjectFromModelDate(this.ytd['value']);
  }

  setAggregation(aggr: string): void {
    const params = this.getParams();
    if (params['component'] == this.constants.COMPONENT.WINDSPEED) {
      this.aggr['value'] = aggr ? aggr : this.constants.AGGR_TYPES.MAX;
    } else if (params['component'] == this.constants.COMPONENT.TEMPERATURE) {
      this.aggr['value'] = aggr ? aggr : this.constants.AGGR_TYPES.DEFAULT;
    } else {
      this.aggr['value'] = aggr ? aggr : this.constants.AGGR_TYPES.SUM;
    }
  }

  isValid(): boolean {
    // return true;
    /**
     * If yearly then either subTime step should be present or start and end date should pe present. Not both.
     */
    // let valid = (this.src['value'] != undefined && this.type['value'] != undefined && this.format['value'] != undefined);
    // if (this.format['value'] == 'YYYY') return valid && this.subTimeStep['value'] != undefined;
    // else return valid && this.sDate['value'] != undefined && this.eDate['value'] != undefiisned;
    this.validation[0] = this.src['value'] != undefined;
    this.validation[1] = this.sDate['value'] != undefined;
    this.validation[2] = this.eDate['value'] != undefined;
    if (this.sDate['value'] != undefined && this.eDate['value'] != undefined) {
      // console.log("this.eDate['value'] ::",this.eDate['value']);
      if (this.selectedvalue == 'Custom') {
        this.validation[3] = this.utilsShared.getModelDateWithDateFormat(this.sDate['value'], this.format['value']) >
          this.utilsShared.getModelDateWithDateFormat(this.eDate['value'], this.format['value']) ? false : true;
      } else {
        this.validation[3] = this.sDate['value'] > this.eDate['value'] ? false : true;
      }
    }
    this.validation[4] = this.aggr['value'] != undefined;
    return this.validation[0] && this.validation[1] && this.validation[2] && this.validation[3] && this.validation[4];
  }

  requestHeatMap(): void {
    this.MobileCustomSetting = false;
    if (this.isValid()) {
      const existingUrlParams = this.getParams();

      let urlParams = Object.assign(existingUrlParams, this.getAsURLParams());
      const rainfallHM = {
        'mapOnClickParams': false,
        'handleEventFromBreadcrumb': false
      };
      urlParams = Object.assign(urlParams, rainfallHM);
      urlParams['src'] = this.selectedSource
      urlParams['loctype'] = this.pType;
      urlParams['cType'] = this.cType;
      urlParams['locuuid'] = this.selectedLocation.split('##')[1];
      urlParams['pEUUID'] = this.selectedLocation.split('##')[1]
      urlParams['locname'] = this.selectedLocation.split('##')[0]
    //   urlParams['srcUUID'] = this.srcUUID;
      // console.log("URLPARAMS::",urlParams,this.srcParams);
      // if(urlParams['pType']) {
        // urlParams['pType'] = ('DISTRICT' || 'BLOCK') ? 'STATE' : urlParams['pType'];
      // }
      // urlParams = Object.assign(urlParams, riverfilter);

      // if (this.selectedView == 'ADMIN') {
        // if (this.src['value'] != this.srcParams) {
        //   const indexOfSource = this.sourceList.findIndex(source => source['key'] == this.src['value']);
        //   if (indexOfSource >= 0) {
        //     urlParams['locname'] = this.sourceList[indexOfSource]['locName'];
        //     urlParams['locuuid'] = this.sourceList[indexOfSource]['locUUID'];
        //     urlParams['loctype'] = this.sourceList[indexOfSource]['locType'];
        //   }
        // }
      // }
      // this.utils.setQueryParams(urlParams);  //for default imd needs to be comment out
      let locName = this.selectedLocation.split('##')[0]
      const districtClicked = {};
      if(locName != 'INDIA') {
        districtClicked['loc'] = this.selectedLocation.split('##')[0];
        districtClicked['locType'] = this.selectedLocation.split('##')[0] == 'INDIA' ? 'Country' : 'State';
        districtClicked['uuid'] = this.selectedLocation.split('##')[1];
        districtClicked['centroid'] = { lat: this.latitude[districtClicked['uuid']], lon: this.longitude[districtClicked['uuid']] };
        districtClicked['zoomLevel'] = 7;
      } else {
        districtClicked['loc'] = 'INDIA';
        districtClicked['locType'] = 'Country';
        districtClicked['uuid'] = this.countryUUID;
        districtClicked['centroid'] = { lat: 20.5937, lon: 78.9629 }
        districtClicked['zoomLevel'] = 7;
      }


      // if(this.utils.getDeviceType()=== "desktop"){
      //   districtClicked['zoomLevel'] = 7;
      // }else{
      //   districtClicked['zoomLevel'] = 6;
      // }

      // districtClicked['centroid'] = {
      //   lat: ProjConstants.STATE_LATLONG_MAPPING[urlParams['locname']][0],
      //   lon: ProjConstants.STATE_LATLONG_MAPPING[urlParams['locname']][1]
      // };
      // districtClicked['centroid'] = { lat: 20.5937, lon: 78.9629 }
      // console.log("Json.parse",JSON.parse(JSON.stringify(urlParams)));
      // this.utils.setDistrictClicked(districtClicked);

      this.utils.setQueryParams(urlParams);  //for default imd needs to be comment out
      if(locName != 'INDIA') {
        this.utils.districtClicked.next(districtClicked)
      }
      // console.log("districtClicked123::",districtClicked);
      // Note:: Was being used for title

      // let index = this.sourceList.findIndex(source => source['key'] == this.src['value']);
      // if (index >= 0) {
      //   this.constants.SELECTED_COMPONENT_CORRESPONDING_DATA.SOURCE = this.constants.COMPONENT_WISE_SOURCE_DISPLAY_NAMES[urlParams['component']][this.sourceList[index]['value']];
      // } else {
      //   this.constants.SELECTED_COMPONENT_CORRESPONDING_DATA.SOURCE = this.constants.COMPONENT_WISE_SOURCE_DISPLAY_NAMES[urlParams['component']][this.defaultSource];
      // }

      // this.constants.SELECTED_COMPONENT_CORRESPONDING_DATA.MAX_DATE = this.utils.getModelDateFromDate(this.maxDate);
      // this.constants.SELECTED_COMPONENT_CORRESPONDING_DATA.MIN_DATE = this.utils.getModelDateFromDate(this.minDate);

    }

  }
  getAsURLParams(): any {
    const params = {};
    if (this) {
      for (const member in this) {
        if (!isNullOrUndefined(member)) {
          const keys = member.toString();
          if (!this[member] || !this[member]['required'] || !this[member]['value']) { continue; }
          let value = this[member]['value'];
          if (this[member]['value'] instanceof Date) {
            value = this.utilsShared.getDateInFormatFromDateObject(this[member]['value'], this.format['value']);
          }
          params[keys] = value.toString();
        }
      }
    }
    return params;
  }

  async selectedoption(): Promise<void> {
    this.utils.setDateRange(this.selectedvalue);
    console.log("JSON SELVAL",JSON.stringify(this.selectedvalue));

    if (this.selectedvalue == 'Custom') {
      this.customOption = false;
    } else {
      this.customOption = true;
    }
    if (this.selectedvalue == 'Live Weather') {
      await this.setDateRangeParametere(this.getParams());
      this.eDate['value'] = this.utilsShared.getModelDateWithDateFormat(this.getLastFewDaysDate(0), this.constants.DATEPICKER_DATE_FORMAT.DAY);
      this.sDate['value'] = this.utilsShared.getModelDateWithDateFormat(this.getLastFewDaysDate(0), this.constants.DATEPICKER_DATE_FORMAT.DAY);
      this.format['value'] = this.constants.DATEPICKER_DATE_FORMAT.DAY;
    } else {
      await this.setsourcelist(this.getParams());
      if (this.selectedvalue == 'Yesterday') {
        this.eDate['value'] = this.utilsShared.getModelDateWithDateFormat(this.getLastFewDaysDate(1), this.constants.DATEPICKER_DATE_FORMAT.DAY);
        this.sDate['value'] = this.utilsShared.getModelDateWithDateFormat(this.getLastFewDaysDate(1), this.constants.DATEPICKER_DATE_FORMAT.DAY);
      }
      if (this.selectedvalue == 'Last 3 Days') {
        this.eDate['value'] = this.utilsShared.getModelDateWithDateFormat(this.getLastFewDaysDate(1), this.constants.DATEPICKER_DATE_FORMAT.DAY);
        this.sDate['value'] = this.utilsShared.getModelDateWithDateFormat(this.getLastFewDaysDate(3), this.constants.DATEPICKER_DATE_FORMAT.DAY);
      }
      if (this.selectedvalue == 'Last 7 Days') {
        this.eDate['value'] = this.utilsShared.getModelDateWithDateFormat(this.getLastFewDaysDate(1), this.constants.DATEPICKER_DATE_FORMAT.DAY);
        this.sDate['value'] = this.utilsShared.getModelDateWithDateFormat(this.getLastFewDaysDate(7), this.constants.DATEPICKER_DATE_FORMAT.DAY);
      }
      if (this.selectedvalue == 'Last 14 Days') {
        this.eDate['value'] = this.utilsShared.getModelDateWithDateFormat(this.getLastFewDaysDate(1), this.constants.DATEPICKER_DATE_FORMAT.DAY);
        this.sDate['value'] = this.utilsShared.getModelDateWithDateFormat(this.getLastFewDaysDate(14), this.constants.DATEPICKER_DATE_FORMAT.DAY);
      }
      if (this.selectedvalue == 'MTD') {
        this.eDate['value'] = this.utilsShared.getModelDateWithDateFormat(this.getLastFewDaysDate(0), this.constants.DATEPICKER_DATE_FORMAT.DAY);
        this.sDate['value'] = this.eDate['value'].substr(0, 6) + '01';
      }
      if (this.selectedvalue == 'Monsoon YTD') {
        this.eDate['value'] = this.utilsShared.getModelDateWithDateFormat(this.getLastFewDaysDate(0), this.constants.DATEPICKER_DATE_FORMAT.DAY);
        this.sDate['value'] = this.utilsShared.getCurrentMonsoonrYearStartDate();
      }
      this.format['value'] = this.constants.DATEPICKER_DATE_FORMAT.DAY;
    }
    console.log("date Stringig",JSON.stringify(this.sDate['value']),JSON.stringify(this.eDate['value']));

  }

  getLastFewDaysDate(days) {
    return new Date(Date.now() - days * 24 * 60 * 60 * 1000);
  }

  infoclick(value) {
    this.modalRef = this.modalService.open(InfomodalComponent, {
      backdrop: 'static',
      keyboard: true,
      windowClass: 'backgroundTransparent  infocomponent',
    });
    this.modalRef.componentInstance.selected = value;
    this.modalRef.componentInstance.infovalue = this.tooltipVal;
    this.modalRef.componentInstance.selectedDate = this.selectedvalue;
  }

  isDesktop(){
    return this.utils.getDeviceType() == "desktop"
  }

  async mobileClickDateRange(dateRange:any){
    if(dateRange=="Custom"){
      this.MobileCustomSetting = true;
    }
    console.log("Date Range Changed");
    console.log("Mobile CLick",this.selectedvalue);
    this.selectedvalue = dateRange;
    await this.selectedoption();

    this.requestHeatMap();
  }

  mobileSourceChanged(source: string, reload: boolean = true){
    this.setSource(source,reload);
    this.requestHeatMap();
  }

  onLocationChange() {
    let stateUUID = this.selectedLocation.split('##')[1]
    if(this.countryUUID != stateUUID) {
      this.weatherDataService.fetchSource(this.countryUUID,stateUUID).subscribe(srcList => {
        this.sourcelist = srcList
        this.pType = 'STATE';
        this.cType = 'DISTRICT';
        this.selectedSource = 'IMD_STATIONS';
      })
    } else {
      this.sourcelist = ['CWC','IMD_STATIONS','IMD_GRID','MERGED_STATIONS','IMD_PRN_STATIONS']
      this.pType = 'COUNTRY';
      this.cType = 'STATE';
      this.selectedSource = 'IMD_STATIONS';
    }
  }

  getLocationList(params) {
    let postData =  {
      "sDate": "20241009",
      "eDate": "20241009",
      "pUUID": "00cb31c7-2928-4e6d-adcc-443d478c90d6",
      "pType": "COUNTRY",
      "format": "DAILY",
      "cType": "STATE",
      "pEUUID": "00cb31c7-2928-4e6d-adcc-443d478c90d6",
      "classification": [
          "ACTUAL"
      ],
      "src": "NHP",
      "aggr": "SUM",
      "includeAllLoc": true
  }

  this.rfSrv.getHWAccuracyData(postData).subscribe(response => {
    // this.locationList = response
    if(Object.keys(response).length > 0) {
      const result = [];
      response.forEach((item) => {
        if (item.md && item.md.ln && item.nm != 'TOTAL') {
          this.locationList.push(item)
            this.latitude[item.uid] = item.md.lt;
            this.longitude[item.uid] = item.md.lng;
        }
      });
      this.locationList.sort((a, b) => a.nm.localeCompare(b.nm));  //sorting states names in alphabetical order
    }
  })
  }

}
